// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3861":"ed4af94882ac48c1","5415":"1d7eea6cde665ecb"}[chunkId] + ".css";
};